import React, { Component } from "react";
import { states } from "../../reducers/queriesStates";
import { withUnitReport } from "../../shared/containers/containerUnitReport";
import { withReportsList } from "../../shared/containers/containerReportsList";
import { withSelectedReports } from "../../shared/containers/containerSelectedReports";
import { withReportTime } from "../../shared/containers/containerReportTime";
import { withReportCar } from "../../shared/containers/containerReportCar";
import { withSelectedCars } from "../../shared/containers/containerSelectedCars";

import CookieService from "../../shared/services/cookiesService";
import configuration from "./../../config.json";
import ReportResult from "../sections/reports/reportResult";
import SelectedReportsList from "../sections/reports/selectedReportsList";
import Preloader from "../../shared/items/static/preloader";
import getDates from "../../shared/services/date.service";

class ReportViewBlock extends Component {
  constructor(props) {
    super(props);

    this.state = { reportTitle: null, selectedReport: null, scrollPositions: [] };
  }

  componentDidMount() {
    const { unitReportDataState } = this.props;

    if (unitReportDataState === states.READY) {
      this.onSetState();
    }
  }

  componentDidUpdate(prevProps) {
    const { unitReportDataState } = this.props;

    if (unitReportDataState === states.REQUEST) {
      this.addReportToHistory();
    }

    if (unitReportDataState === states.READY && prevProps.unitReportDataState === states.REQUEST) {
      this.onSetState();
    }
  }

  addReportToHistory() {
    const { selectedCars, selectedReports, reportStartDate, reportStartTime, reportEndDate, reportEndTime } = this.props;

    const reportsHistoryList = !!localStorage.getItem(configuration.reportsHistory)
      ? JSON.parse(localStorage.getItem(configuration.reportsHistory))
      : [];

    const authData = JSON.parse(CookieService.getCookie(configuration.cookieName));
    const email = authData.email;
    const userHistoryItem = reportsHistoryList.find((item) => item.email === email);
    reportStartDate.setHours(reportStartTime.getHours());
    reportStartDate.setMinutes(reportStartTime.getMinutes());
    reportEndDate.setHours(reportEndTime.getHours());
    reportEndDate.setMinutes(reportEndTime.getMinutes());

    if (userHistoryItem) {
      const userHistoryList = userHistoryItem.list;

      userHistoryList.unshift({
        cars: selectedCars,
        reports: selectedReports,
        reportStartDate: reportStartDate,
        currentDate: new Date(),
        reportEndDate: reportEndDate,
      });

      userHistoryItem.list = userHistoryList.length > 20 ? userHistoryList.slice(0, 20) : userHistoryList;
    } else {
      reportsHistoryList.push({
        email: email,
        list: [
          {
            cars: selectedCars,
            reports: selectedReports,
            reportStartDate: reportStartDate,
            currentDate: new Date(),
            reportEndDate: reportEndDate,
          },
        ],
      });
    }

    localStorage.setItem(configuration.reportsHistory, JSON.stringify(reportsHistoryList));
  }

  onSetState() {
    const { selectedReports, reportStartDate, reportStartTime, reportEndDate, reportEndTime, unitsReportData } = this.props;

    const start = getDates.getDateFormat4(getDates.concat(reportStartDate, reportStartTime));
    const end = getDates.getDateFormat4(getDates.concat(reportEndDate, reportEndTime));

    this.setState({
      reportTitle: `${selectedReports[0].title} c  ${start} по ${end}`,
      selectedReport: selectedReports[0],
      scrollPositions: unitsReportData.units.map((unit) => {
        return {
          id: unit.info.id,
          scroll: 0,
        };
      }),
    });
  }

  onSetSctollUnitReport(unitId, scroll) {
    const { scrollPositions } = this.state;

    const scrolls = scrollPositions.map((item) => {
      if (item.id === unitId) {
        item.scroll = scroll;
      }

      return item;
    });

    this.setState({ scrollPositions: scrolls });
  }

  render() {
    const { unitReportDataState, unitsReportData, reportCarId } = this.props;
    const { reportTitle, selectedReport, scrollPositions } = this.state;

    if (unitReportDataState === states.REQUEST) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Preloader />
        </div>
      );
    }

    return (
      <>
        <SelectedReportsList title={reportTitle} />

        {unitReportDataState === states.READY || unitReportDataState === states.FAILURE ? (
          <ReportResult
            report={selectedReport}
            unitsReportData={unitsReportData}
            unitId={reportCarId}
            scrollPositions={scrollPositions}
            onSetSctollUnitReport={this.onSetSctollUnitReport.bind(this)}
          />
        ) : null}
      </>
    );
  }
}

export default withReportTime(withUnitReport(withSelectedReports(withSelectedCars(withReportCar(withReportsList(ReportViewBlock))))));
